
   

<!--_________header component ________-->
<app-header></app-header>





<div class="container">
  <router-outlet></router-outlet>
</div>




<!--_______ footer component ________-->
<app-footer></app-footer>

